import React, { useEffect, useState } from "react";
import { createClient } from "@supabase/supabase-js";
// hooks
import useOwnedNFTs from "./useOwnedNFTs";
import { useAcreDapp } from "../providers/AcreDappProvider/AcreDappProvider";

// utils
import {
  getPropertyMetadataForNFT,
  LISTING_TYPE,
  RENTAL_CONTRACT_SECONDS_PER_INTERVAL,
  SEC_IN_A_DAY,
} from "../platformUtils";

function useOwnedProperties() {
  // const ownedNFTs = useOwnedNFTs();
  const { walletAddress } = useAcreDapp();
  const [ownedProperties, setOwnedProperties] = useState([]);
  const supabase = createClient(
    `https://${process.env.REACT_APP_SUPABASE_URL}.supabase.co`,
    `${process.env.REACT_APP_SUPABASE_API_KEY}`
  );

  useEffect(() => {
    // async function getAllPropertiesMetadata() {
    //     let promises = [];
    //     let propertyDataWIP = [];

    //     for(let nft of ownedNFTs) {
    //         promises.push(new Promise((resolve, reject) => {
    //             getPropertyMetadataForNFT(nft)
    //             .then((propertyData) => {
    //                 // TODO: remove dummy data
    //                 propertyData.owner = '0x1234567890abcdef';
    //                 if(propertyData.rentalInfo) {
    //                     propertyData.rentalInfo.tenant = '0x1234567890abcdef';
    //                     propertyData.rentalInfo.landlord = '0xcccccccccccc';
    //                 }

    //                 if(nft.isProperty)
    //                     propertyDataWIP.push(nft);

    //                 resolve();
    //             })
    //         }))
    //     }

    //     await Promise.all(promises);

    //     setOwnedProperties(propertyDataWIP);
    // }

    // getAllPropertiesMetadata();
    const getOwnedListings = async () => {
      try {
        let { data, error, status } = await supabase
          .from("listings")
          .select()
          .eq("user_wallet_address", walletAddress);

        if (error && status !== 406) {
          throw error;
        }
        if (data) {
          setOwnedProperties(data);
        }
        if (status) {
          console.log("Database status: ", status);
        }
      } catch (error) {
        console.table(error);
      }
    };
    if (walletAddress) getOwnedListings();
    return () => {
      return;
    };
  }, [walletAddress]);

  return ownedProperties;
}
export default useOwnedProperties;
